import React from 'react';

const ButtonsTotals = (props) => (
    <div className="list-group">
        <button type="button" className="list-group-item list-group-item-action">
            Total Captaciones <span className="badge badge-light">{props.totalRecruited}</span>
        </button>
        <button type="button" className="list-group-item list-group-item-action">
            Total a Pagar <span className="badge badge-light">{props.total.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</span>
        </button>
        <button type="button" className="list-group-item list-group-item-action">
            Total sin Aprobar <span className="badge badge-light">{props.totalPending.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</span>
        </button>
        <button
            type="button"
            className={`list-group-item list-group-item-action ${props.searchApprovedStatus === ''? '' : 'active'}`}
            onClick={() => props.onChangeFilter('searchApprovedStatus', props.searchApprovedStatus === '' ?  3 : '')}
        >
            Operadores Pendientes <span className="badge badge-light">{props.countPendingApproval}</span>
        </button>
        <button type="button" className="list-group-item list-group-item-action">
            Boletas No Emitidas <span className="badge badge-light">{props.countFeeTicketsPending}</span>
        </button>
        <button type="button" className="list-group-item list-group-item-action">
            Boletas Con Diferencias <span className="badge badge-light">{props.countFeeTicketsDiff}</span>
        </button>
    </div>
);

export default ButtonsTotals;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/ButtonsTotals.jsx